/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Requirements_ExceptedInputs */

const en_case_requirements_excepted = /** @type {(inputs: Case_Requirements_ExceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exception approved`)
};

const pt_br2_case_requirements_excepted = /** @type {(inputs: Case_Requirements_ExceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exceção aprovada`)
};

/**
* | output |
* | --- |
* | "Exception approved" |
*
* @param {Case_Requirements_ExceptedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_requirements_excepted = /** @type {((inputs?: Case_Requirements_ExceptedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Requirements_ExceptedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_requirements_excepted(inputs)
	return pt_br2_case_requirements_excepted(inputs)
});